module.exports = __webpack_public_path__ + "img/carotid.fe3fc63a.png";